import { render, staticRenderFns } from "./EventProductSalePaypal.vue?vue&type=template&id=2ad51bab&"
import script from "./EventProductSalePaypal.vue?vue&type=script&lang=js&"
export * from "./EventProductSalePaypal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VAlert,
  VBtn,
  VContainer,
  VFlex,
  VLayout,
})
